import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';
import { ReactComponent as IcoCode } from '../../assets/ico-code.svg';
import { ReactComponent as IcoEye } from '../../assets/ico-eye.svg';

export default function ProjectItem({ project }) {
    const { technologies } = project;

    return (
        <Container
            theme={project.theme}
            visibility={project.uri_liveview ? 'visible' : 'hidden'}
        >
            <header>
                <img alt={project.fullname} />
                <h2>
                    <span>{project.name}</span>
                    <span>{project.surname}</span>
                </h2>
            </header>
            <p>{project.description}</p>
            <div>
                <ul>
                    <header>
                        <strong>Tecnologias e Conceitos</strong>
                    </header>
                    {technologies.map((technology, index) => (
                        <li key={String(index)}>{technology}</li>
                    ))}
                </ul>
            </div>
            <a href={project.uri_liveview} target="blank">
                <IcoEye />
                <p>VER PROJETO</p>
            </a>
            <a href={project.uri_repository} target="blank">
                <IcoCode />
                <p>VER CÓDIGO</p>
            </a>
        </Container>
    );
}

ProjectItem.propTypes = {
    project: PropTypes.shape({
        theme: PropTypes.string,
        uri_liveview: PropTypes.string,
        uri_repository: PropTypes.string,
        fullname: PropTypes.string,
        name: PropTypes.string,
        surname: PropTypes.string,
        description: PropTypes.string,
        technologies: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};
